import { getApi, getLocalJsonApi, postApi } from "../api/api"
import { fetchToken, generateTokenDataString, generateTokenRequest, getSessionId, getStoredToken, getUserId, setTokenToStorage } from "./tokenService";
// eslint-disable-next-line no-unused-expressions
import { authEncryptFunction } from '../components/appencrypt2.2v1/appencrypt';
import { APP_PLATFORM_ID } from "../constants/data";
import { xMerckApiKey } from "../constants/env";

const qolDecryptApi = async (data_string, extraPayload = {}) => {
    let tokenData = getStoredToken(), token;
    if(tokenData) {
        if (new Date(tokenData.storedExpiry) - new Date() <= 0) {
            // ToDo: navigate to login
            console.log('expired');
            return {data : {RESPONSE_STATUS_CD: 'EXPIRED'}};
        } else {
            token = tokenData.storedToken;
        }
    }
    if(!token) {
        const dataString = authEncryptFunction(generateTokenDataString());
        const authString = authEncryptFunction(generateTokenRequest());
        const resp = await fetchToken(authString, dataString);
        token = resp.data.DATA.TOKEN;
        setTokenToStorage(token, resp.data.DATA.EXPIRY);
    }

    console.log(typeof(data_string));
    if(typeof(data_string) == 'string'){
        data_string = {DATA_STRING: data_string}
    }

    const payload = {
        APP_PLATFORM_ID: APP_PLATFORM_ID,
        ...data_string,
        ...extraPayload
    };

    const headers = {
        token: token,
        userId: getUserId(),
        sessionId: getSessionId(),
        'X-Merck-APIKey': xMerckApiKey
    };
    return await postApi('/qoldecrypt', payload, headers);
}

export const searchApi = async (data_string) => {
    return await qolDecryptApi(data_string);
}

export const poDetailApi = async (data_string) => {
    return await qolDecryptApi(data_string);
}

export const poRegistrationApi = async (data_string, extraPayload) => {
    return await qolDecryptApi(data_string, extraPayload);
}

export const popFetchBreedsApi = async () => {
    return await getLocalJsonApi('/appData/breeds.json');
}

export const popCreatePetApi = async (data_string, extraPayload) => {
    return await qolDecryptApi(data_string, extraPayload);
}

export const generateDataStringObject = (moduleName) => {
    return {
        "SESSION_ID": getSessionId(),
        "USER_ID": getUserId(),
        "MODULE_NAME": moduleName || "petownersearch",
        "DATA_JSON": ""
    }
}

